module.exports = __webpack_public_path__ + "img/programme7.6c207680.png";